import React from 'react';
import { isEqual } from 'lodash/lang';

import DatePicker from '../../../../common/data-entry/DatePicker';
import { isNextMonthOrBefore } from '../../../../services/date/validators';

export default function MonthFilter({ dateToShow, handleMChange }) {
  return (
    <div className="month-select" data-testid="month-selector">
      <DatePicker
        value={dateToShow}
        label="Month"
        timeFormat={false}
        closeOnSelect
        className="calendar-input"
        onChange={monthOnChange}
        viewMode="months"
        dateFormat="MMMM YYYY"
        readOnly={true}
        isValidDate={isNextMonthOrBefore}
        data-testid="month-selector"
      />
    </div>
  );
  function monthOnChange(date) {
    if (!(isEqual(date.month(), dateToShow.month()) && isEqual(date.year(), dateToShow.year()))) {
      handleMChange(date);
    }
  }
}
